import React from 'react'
import Popover from '@material-ui/core/Popover'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
    popover: {
        pointerEvents: 'none',
    },
    paper: {
        padding: theme.spacing(1),
    },
}))

export default function CustomPopover(props) {
    const classes = useStyles()
    const [anchorEl, setAnchorEl] = React.useState(null)
    const [open, setOpen] = React.useState(false)
    const hoverTimeoutRef = React.useRef()

    const handlePopoverOpen = (event) => {
        clearTimeout(hoverTimeoutRef.current)
        setAnchorEl(event.currentTarget) // ✅ Set immediately
        hoverTimeoutRef.current = setTimeout(() => {
            setOpen(true)
        }, 300)
    }

    const handlePopoverClose = () => {
        clearTimeout(hoverTimeoutRef.current)
        hoverTimeoutRef.current = setTimeout(() => {
            setOpen(false)
            setAnchorEl(null)
        }, 300)
    }

    return (
        <div>
            <Typography
                className={`cursorDecoy ${props.tltpClass}`}
                aria-owns={open ? 'mouse-over-popover' : undefined}
                aria-haspopup="true"
                onMouseEnter={handlePopoverOpen}
                onMouseLeave={handlePopoverClose}
                style={props.style}
            >
                {props.label}
            </Typography>
            <Popover
                id="mouse-over-popover"
                className={`${classes.popover} ${props.popOverClass}`}
                classes={{
                    paper: classes.paper,
                }}
                open={open}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                onClose={handlePopoverClose}
                disableRestoreFocus
            >
                <Typography>
                    <div className="popOverBody">{props.content}</div>
                </Typography>
            </Popover>
        </div>
    )
}
